// src/views/menage/RangeePastillesAgents.jsx — LA RANGÉE DE PASTILLES D'AGENTS
// (correction Dimitri 22/08, téléphone) : le <select> natif ouvrait un choix
// « énorme et très loin » de la ligne du logement — le lien se perdait. La
// forme validée de la frise s'applique : pastilles 44 px, l'ACTIF à bord navy
// 2 px sur fond #e8f2fa, DIRECTEMENT sous la ligne. Téléphone seulement —
// l'ordinateur garde ses <select>.

import { DS } from '../../lib/ui'

export default function RangeePastillesAgents({ options, actif, onChoisir, testPrefix, occupe = false }) {
  return (
    <div data-testid={`${testPrefix}-pastilles`}
      style={{ display: 'flex', flexWrap: 'wrap', gap: 6, width: '100%', marginTop: 7 }}>
      {options.map((o) => {
        const estActif = (o.value || '') === (actif || '')
        return (
          <button key={o.value || '__aucun__'} type="button"
            data-testid={`${testPrefix}-pastille-${o.value || 'aucun'}`}
            disabled={occupe || o.disabled}
            aria-pressed={estActif}
            onClick={() => { if (!estActif && onChoisir) onChoisir(o.value) }}
            className="fbz-press"
            style={{ display: 'inline-flex', alignItems: 'center', gap: 5,
              minHeight: 44, padding: '5px 13px', borderRadius: 10,
              border: estActif ? '2px solid #3d5166' : '1px solid #c3d5e4',
              background: estActif ? '#e8f2fa' : '#fff',
              color: o.disabled ? '#98a2ad' : estActif ? '#233240' : '#3d5166',
              fontSize: 12, fontWeight: 700, fontFamily: DS.fontBody,
              cursor: occupe || o.disabled ? 'default' : 'pointer',
              opacity: o.disabled ? 0.6 : 1, whiteSpace: 'nowrap' }}>
            {o.label}
          </button>
        )
      })}
    </div>
  )
}
